import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

import { ProductAsset } from './types';

// The toggleable product-photo grid shared by the Generate and Re-roll
// dialogs — one implementation so the two can't drift. Controlled: the caller
// owns the chosen set and any deselect-all warnings.

interface ProductAssetPickerProps {
  assets: ProductAsset[];
  chosen: Set<string>;
  onToggle: (assetId: string) => void;
  caption?: string;
}

export default function ProductAssetPicker({ assets, chosen, onToggle, caption }: ProductAssetPickerProps) {
  if (!assets.length) return null;
  return (
    <Box>
      <Typography variant="caption" color="text.secondary">
        {caption || 'Reference photos to attach'} ({chosen.size} of {assets.length})
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(84px, 1fr))', gap: 1, mt: 0.5 }}>
        {assets.map((asset) => {
          const on = chosen.has(asset.assetId);
          return (
            <Box
              key={asset.assetId}
              onClick={() => onToggle(asset.assetId)}
              sx={{
                position: 'relative', cursor: 'pointer', borderRadius: 1, overflow: 'hidden',
                border: 2, borderColor: on ? 'primary.main' : 'divider',
                opacity: on ? 1 : 0.45, aspectRatio: '1 / 1', bgcolor: 'grey.100',
              }}
            >
              <Box
                component="img"
                src={asset.thumbnailUrl || asset.imageUrl || ''}
                alt={asset.caption || 'Product reference'}
                sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
              />
              {on
                ? <CheckCircleIcon color="primary" sx={{ position: 'absolute', top: 2, right: 2, fontSize: 18, bgcolor: 'background.paper', borderRadius: '50%' }} />
                : <RadioButtonUncheckedIcon sx={{ position: 'absolute', top: 2, right: 2, fontSize: 18, color: 'text.disabled', bgcolor: 'background.paper', borderRadius: '50%' }} />}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
